module.exports = __webpack_public_path__ + "img/text02.67139b44.svg";